import { useCallback } from 'react';

import { CardProps, CardSides } from './types';

function useUpdateCard({
  updateAttrs,
  card,
  side,
}: {
  updateAttrs: (attrs: Object) => void;
  card?: Record<CardSides, CardProps>;
  side: CardSides;
}) {
  const onUpdateCardAttrs = useCallback(
    (prop: string, value: string | boolean | null) => {
      updateAttrs({
        card: {
          ...card,
          [side]: {
            ...card?.[side],
            [prop]: value,
          },
        },
      });
    },
    [card, side, updateAttrs],
  );

  const onHeadingChange = useCallback(
    (value: string) => {
      onUpdateCardAttrs('heading', value);
    },
    [onUpdateCardAttrs],
  );

  const onDescriptionChange = useCallback(
    (value: string) => {
      onUpdateCardAttrs('description', value);
    },
    [onUpdateCardAttrs],
  );

  const onImageChange = useCallback(
    (value: string | null) => {
      onUpdateCardAttrs('backgroundImgSrc', value);
    },
    [onUpdateCardAttrs],
  );

  const toggleHeadingDisplay = useCallback(() => {
    onUpdateCardAttrs('showHeading', !card?.[side]?.showHeading);
  }, [card, onUpdateCardAttrs, side]);

  return {
    onHeadingChange,
    onDescriptionChange,
    toggleHeadingDisplay,
    onImageChange,
  };
}

export default useUpdateCard;
